export const PATH = {
  CONTACT: '/kontakt',
  COOKIE_POLICY: '/polityka-prywatnosci',
  HOME: '/',
  LEASE_TERMS: '/warunki-wynajmu',
  NOT_FOUND: '/not_found',
  PRICE_LIST: '/cennik',
  SERVICES: '/uslugi',
  VEHICLE_DETAIL: `/samochody/:vehicleId`,
  VEHICLES: '/samochody',
};
export const enum PAGE_SLUG {
  CONTACT = 'contact',
  COOKIE_POLICY = 'cookie-policy',
  HOME = 'home',
  LEASE_TERMS = 'lease-terms',
  NOT_FOUND = 'not-found',
  PRICE_LIST = 'price-list',
  SERVICES = 'services',
  VEHICLE_DETAIL = 'vehicle',
  VEHICLES = 'vehicles',
}
